import axios from 'axios';
import moment from 'moment'

const TOKEN_NAME = 'synkedup_token'

const env = window.env ?? { VERSION: '0.0.0' }

const getAccessToken = () => {
  let token = {};
  if (typeof localStorage !== 'undefined' && localStorage !== null) {
    try {
      token = JSON.parse(localStorage.getItem(TOKEN_NAME)) || {};
    } catch { }
  }
  if (token.access_token && moment(token.expires) > moment()) {
    return 'Bearer ' + token.access_token
  } else {
    return null
  }
}

const getHeaders = () => {
  const accessToken = getAccessToken();
  if (accessToken) {
    return {
      'Authorization': accessToken,
      'synkedup-version': `web ${env.VERSION}`
    }
  } else {
    return {
      'synkedup-version': `web ${env.VERSION}`
    }
  }
}

/*
  Sets authorization headers on instances.
*/
const updateInstancesHeaders = () => {
  // Alter defaults after instance has been created
  instance.defaults.headers.Authorization = getAccessToken()
}

/*
  Sets base urls on instances.
*/
const updateInstancesBaseUrls = () => {
  instance.defaults.baseURL = env.API_ENDPOINT
}

/*
  Function called on sign in success. Updates instances parameters:
    authorization headers + base url
  Right time to call at sign in, after angular app has set the local storage parameters
*/
export const updateInstances = () => {
  updateInstancesHeaders()
  updateInstancesBaseUrls()
}

const getNewAxiosInstance = () => {
  const headers = getHeaders()
  return axios.create({
    baseURL: env.API_ENDPOINT,
    headers
  });
}

let instance = getNewAxiosInstance()
export default instance
